import { createStrings } from '@utils/local';
import { PageMeta } from '@utils/pages';

const strings = createStrings({
  ja: {
    title: 'ダッシュボード',
  },
});

export const meta: PageMeta = {
  title: strings.title,
  order: 1,
};
